import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  RESET_LOGIN_FLAG,
  LOGIN_FAILED,
  GET_USER_ORG,
  GET_USER_ORG_SUCCESS,
  GET_USER_ORG_FAILURE,
} from "./actionTypes";

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  };
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const loginFailed = (error) => {
  return {
    type: LOGIN_FAILED,
    payload: error,
  };
};

export const logoutUser = (history) => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};

export const resetLoginFlag = () => {
  return {
    type: RESET_LOGIN_FLAG,
  };
};

export const getUserOrganisation = (history) => {
  return {
    type: GET_USER_ORG,
    payload: { history },
  };
};

// export const getUserOrganisationFailure = error => {
//   return {
//     type: GET_USER_ORG_FAILURE,
//     payload: error
//   }
// }

// export const getUserOrganisationSuccess = org => {
//   return {
//     type: GET_USER_ORG_SUCCESS,
//     payload: org
//   }
// }
